// #endregion
/**
 * 公司-组织权限
 */
export var E_Company_Organization;
(function (E_Company_Organization) {
    /**
     * 如果有这个权限,则可以访问产品列表、权限列表、设置的默认属性、报告、
     */
    E_Company_Organization["CompanyOrganizationDetailInfo"] = "/backoffice/companies/{companyId}";
    E_Company_Organization["CompanyPrivilegeList"] = "/backoffice/company-privilege/company/{companyId}";
    E_Company_Organization["CompanyHistoryList"] = "/backoffice/logauditrecords/{entityId}";
})(E_Company_Organization || (E_Company_Organization = {}));
/**
 * 公司-组织-设置
 */
export var E_Company_Organization_Setting;
(function (E_Company_Organization_Setting) {
    /**
     * 1.做了接口拆分：安全设置 为原接口
     * 2.对应 编辑组织安全设置 服务
     * 3.如果有此权限公司-组织设置-安全 方可编辑
     */
    E_Company_Organization_Setting["SecuritySettingSubmit"] = "/backoffice/companies/{id}";
    E_Company_Organization_Setting["SecuritySettingIpDomainSubmit"] = "/backoffice/companies/trial/security-settings";
    E_Company_Organization_Setting["GetSecuritySetting"] = "/backoffice/companies/security/{companyId}";
    /**
     *  新增常规设置、SSO 设置接口
     */
    E_Company_Organization_Setting["SsoSettingSubmit"] = "/backoffice/companies/sso/{id}";
    E_Company_Organization_Setting["GeneralSettingSubmit"] = "/backoffice/companies/general/{id}";
    /**
     * 设置
     */
    E_Company_Organization_Setting["SettingsSubmit"] = "/backoffice/companies/{id}/setting";
    /** grant 设置 */
    E_Company_Organization_Setting["GetGrantSetting"] = "";
    /** 系统限制 */
    E_Company_Organization_Setting["CompanySystemLimit"] = "/backoffice/companies/system/limit/{companyId}";
    E_Company_Organization_Setting["PatchCompanySystemLimit"] = "/backoffice/companies/system/limit/{companyId}";
    E_Company_Organization_Setting["PostCompaniesUnbindUserCarsi"] = "/backoffice/companies/unbind-users-carsi/{companyId}";
    E_Company_Organization_Setting["PatchCompaniesSystemJwtSsoDisplay"] = "/backoffice/companies/system/jwt-sso-display/{companyId}";
    /** 公司默认设置 */
    E_Company_Organization_Setting["CompanyDefaultPreference"] = "/backoffice/companies/security/{companyId}";
    /** 公司邮件订阅 */
    E_Company_Organization_Setting["CompanySubscriptions"] = "/backoffice/mail-config-company/tenant";
    /** 公司邮件订阅设置 */
    E_Company_Organization_Setting["CompanySubscriptionsSetting"] = "/backoffice/mail-config-company";
})(E_Company_Organization_Setting || (E_Company_Organization_Setting = {}));
// #endregion
/**
 * 账号列表 || 公司-组织-账号
 */
export var E_Account;
(function (E_Account) {
    E_Account["AccountsList"] = "/backoffice/accounts/pagination";
    /**
     * 账号详情
     */
    E_Account["AccountsDetail"] = "/backoffice/accounts/account-basic";
    E_Account["AccountInfoReport"] = "/backoffice/company-rpt/account/{accountId}/{chartId}";
    /**
     * 账号详情：编辑:有则可编辑表单中的 管理员or普通用户/同时登录数
     */
    E_Account["AccountDetailEditUserRole"] = "/backoffice/tenant-users/batch/job-role";
    E_Account["AccountSetting"] = "/backoffice/accounts/setting";
    E_Account["AccountSecuritySetting"] = "/backoffice/tenant-users/batch/ip-restrict";
    /** 帐号 产品 */
    E_Account["AccountProduct"] = "/backoffice/tenant-users/privilege-view";
    // 帐号默认设置
    E_Account["AccountDefaultPreference"] = "/backoffice/tenant-users/setting-basic";
    E_Account["AccountSystemLimit"] = "/backoffice/accounts/system/limit/{accountId}";
    E_Account["AccountSubscriptions"] = "/backoffice/mail-config-user/user";
    E_Account["AccountSubscriptionsSetting"] = "/backoffice/mail-config-user";
})(E_Account || (E_Account = {}));
/* 故障排除 */
export var E_Troubleshooting;
(function (E_Troubleshooting) {
    /**
     * 邮件配置
     */
    E_Troubleshooting["MailConfigList"] = "/backoffice/mail-config/pagination";
    /* 邮件发送 */
    E_Troubleshooting["MailSendList"] = "/backoffice/mails";
    /* 邮件接收 */
    E_Troubleshooting["MailRecepitList"] = "/backoffice/mail/receipts";
    /* 不可达邮件 */
    E_Troubleshooting["MailUnreachableGetList"] = "/backoffice/mail-unreachable";
    /* 短信发送 */
    E_Troubleshooting["MessageSend"] = "/backoffice/messages";
    /* 会话踢出信息  */
    E_Troubleshooting["SessionKickoutauditrecordsGetList"] = "/backoffice/kickoutauditrecords/pagination";
    /* 历史信息  */
    E_Troubleshooting["HistoryGetList"] = "/backoffice/logauditrecords/pagination";
})(E_Troubleshooting || (E_Troubleshooting = {}));
export var E_SessionManagement;
(function (E_SessionManagement) {
    E_SessionManagement["CompanySessionGetList"] = "/backoffice/session/companies/{companyId}/sessions";
    E_SessionManagement["AccountSessionGetList"] = "/backoffice/session/accounts/sessions";
})(E_SessionManagement || (E_SessionManagement = {}));
// #region
/* 运营工具 */
export var E_OperationTool;
(function (E_OperationTool) {
    E_OperationTool["PatsnapLab"] = "/backoffice/patsnap-lab";
    E_OperationTool["NavigationLibrary"] = "/backoffice/navigation-library";
    E_OperationTool["RecommendationManagement"] = "/backoffice/recommendation-management";
    /**  申请试用列表 */
    E_OperationTool["ApplyTrialList"] = "/backoffice/self-register/safe";
    /**  申请试用每天注册上限 */
    E_OperationTool["ApplyTrialPutNoticeLimitation"] = "/backoffice/self-register/notice/limitation";
    /**  申请试用临时调整上限 */
    E_OperationTool["ApplyTrialputIpLimitation"] = "/backoffice/self-register/ip/limitation";
    E_OperationTool["PromptManagement"] = "/backoffice/prompt/list";
    E_OperationTool["EmailTemplateManagement"] = "/backoffice/email-template/list";
    E_OperationTool["OrganizationManagement"] = "/backoffice/bei-sen/department";
})(E_OperationTool || (E_OperationTool = {}));
/**
 * PatsnapLab
 */
export var E_PatsnapLab;
(function (E_PatsnapLab) {
    E_PatsnapLab["AppManagement"] = "/backoffice/patsnapLab-app-management";
    E_PatsnapLab["AbTestManagement"] = "/backoffice/patsnapLab-abtest-management";
    E_PatsnapLab["AppAnalysis"] = "/backoffice/patsnapLab-app-analysis";
    E_PatsnapLab["SuggestionFeedback"] = "/backoffice/patsnapLab-feedback";
})(E_PatsnapLab || (E_PatsnapLab = {}));
/**
 * 推荐管理
 */
export var E_RecommendationManagement;
(function (E_RecommendationManagement) {
    E_RecommendationManagement["HomePageConfiguration"] = "/backoffice/recommendationManagement-home-page-configuration";
    E_RecommendationManagement["EditorsPickManagement"] = "/backoffice/recommendationManagement-editors-pick-management";
})(E_RecommendationManagement || (E_RecommendationManagement = {}));
/* 工作空间 */
export var E_Workspace;
(function (E_Workspace) {
    E_Workspace["TaskCenter"] = "/backoffice/workspace-task-center";
    E_Workspace["DataMigration"] = "/backoffice/workspace-data-migration";
    E_Workspace["DataAnalysis"] = "/backoffice/workspace-data-analysis";
    E_Workspace["SeparateDataManagement"] = "/backoffice/workspace-separate-data-management";
    E_Workspace["SeparateDataStatistics"] = "/backoffice/workspace-separate-data-statistics";
})(E_Workspace || (E_Workspace = {}));
// 导航库
export var E_NavigationLibrary;
(function (E_NavigationLibrary) {
    E_NavigationLibrary["NavigationLibraryOperation"] = "/backoffice/navigation-library-operation";
    E_NavigationLibrary["NavigationLibraryAudit"] = "/backoffice/navigation-library-audit";
    E_NavigationLibrary["AgencyList"] = "/backoffice/navigation-library-agency";
})(E_NavigationLibrary || (E_NavigationLibrary = {}));
/* OpenApi */
export var E_OpenApi;
(function (E_OpenApi) {
    E_OpenApi["MenuClassification"] = "/backoffice/openApi-menu-classification";
    E_OpenApi["ApiConfig"] = "/backoffice/openApi-api-config";
    E_OpenApi["ApiWhitelist"] = "/backoffice/openApi-api-whitelist";
    E_OpenApi["ProductPackageManagement"] = "/backoffice/openApi-product-package-management";
    E_OpenApi["MonthlyBill"] = "/backoffice/open-api-monthly-bill";
    E_OpenApi["PackageUsage"] = "/backoffice/open-api-package-usage";
    E_OpenApi["CustomerUsageRanking"] = "/backoffice/open-api-customer-usage-ranking";
    E_OpenApi["PackeageUsageRanking"] = "/backoffice/open-api-package-usage-ranking";
    E_OpenApi["APIUsageRanking"] = "/backoffice/open-api-api-usage-ranking";
    E_OpenApi["ContentConfigurableIndex"] = "/backoffice/open-api-content-configurable-index";
    E_OpenApi["ContentConfigurableSolutionGroup"] = "/backoffice/open-api-content-configurable-solution-group";
    E_OpenApi["ContentConfigurableSolution"] = "/backoffice/open-api-content-configurable-solution";
    E_OpenApi["ContentConfigurableDataPackage"] = "/backoffice/open-api-content-configurable-data-package";
    // 套餐key
    E_OpenApi["PackageKey"] = "/backoffice/open-api-package-key";
})(E_OpenApi || (E_OpenApi = {}));
/* 开放平台 */
export var E_OpenPlatform;
(function (E_OpenPlatform) {
    E_OpenPlatform["ApiAnalysis"] = "/backoffice/clients/{companyId}/client";
    E_OpenPlatform["ProductClient"] = "/backoffice/clients/{clientId}";
    E_OpenPlatform["ProductBundle"] = "/backoffice/bundles/{id}";
    E_OpenPlatform["ProductClientBundle"] = "/backoffice/client-bundles/client/{clientId}";
    E_OpenPlatform["GatewayManagement"] = "/backoffice/gateway/pagination";
})(E_OpenPlatform || (E_OpenPlatform = {}));
/* 申请试用(自注册) */
export var E_ApplyTrial;
(function (E_ApplyTrial) {
    E_ApplyTrial["ApplyTrialList"] = "/backoffice/self-register/safe";
    E_ApplyTrial["ApplyTrialPutNoticeLimitation"] = "/backoffice/self-register/notice/limitation";
    E_ApplyTrial["ApplyTrialputIpLimitation"] = "/backoffice/self-register/ip/limitation";
    // 分析页面:
    E_ApplyTrial["ApplyTrialAnalysis"] = "/backoffice/self-register/analysis";
})(E_ApplyTrial || (E_ApplyTrial = {}));
/* 数据保护 */
export var E_DataProtection;
(function (E_DataProtection) {
    E_DataProtection["ExportManagement"] = "/backoffice/data-protection-export-management";
    E_DataProtection["RestrictionList"] = "/backoffice/data-protection-restriction-list";
    E_DataProtection["RestrictionListOperationDisable"] = "/backoffice/data-protection-restriction-list-operation-disable";
    E_DataProtection["RestrictionListOperationRelieve"] = "/backoffice/data-protection-restriction-list-operation-relieve";
    E_DataProtection["RestrictionListOperationDetail"] = "/backoffice/data-protection-restriction-list-operation-detail";
    /** 先用data-protection-restriction-list的权限 */
    E_DataProtection["WhiteList"] = "/backoffice/data-protection-white-list";
    E_DataProtection["CompanyTree"] = "/backoffice/restriction-management-company-tree";
    E_DataProtection["UserRestrictedQuery"] = "/backoffice/data-protection-user-restricted-query";
})(E_DataProtection || (E_DataProtection = {}));
// #endregion
/**
 * 违规carsi
 */
export var E_IllegalManagement;
(function (E_IllegalManagement) {
    E_IllegalManagement["CarsiSuspectSellUserList"] = "/backoffice/carsi-suspect-sell/user/pagination";
    E_IllegalManagement["CarsiSuspectSellIPList"] = "/backoffice/carsi-suspect-sell/black-ip/pagination";
    E_IllegalManagement["CarsiSuspectSellTenantList"] = "/backoffice/carsi-suspect-sell/tenant/pagination";
})(E_IllegalManagement || (E_IllegalManagement = {}));
// #region  开发工具
/* 开发工具 */
export var E_DeveloperTool;
(function (E_DeveloperTool) {
    E_DeveloperTool["SystemcodeGetList"] = "/backoffice/systemcode/types/codes";
    E_DeveloperTool["BlackQuery"] = "/backoffice/patsnap-operation/export-black-query-management";
})(E_DeveloperTool || (E_DeveloperTool = {}));
export var E_CoreUtility;
(function (E_CoreUtility) {
    E_CoreUtility["AccountInformationQuery"] = "/backoffice/coreUtility-account-Information-query";
    E_CoreUtility["CoreUtilityCacheManagement"] = "/backoffice/coreUtility-cache-management";
    E_CoreUtility["EmailAlertTest"] = "/backoffice/coreUtility-email-alert-test";
    E_CoreUtility["EmailAlertDebugger"] = "/backoffice/coreUtility-email-alert-test";
    E_CoreUtility["GatewayPermissions"] = "/backoffice/coreUtility-gateway-permissions";
    E_CoreUtility["Limitation"] = "/backoffice/coreUtility-limitation";
    E_CoreUtility["postman"] = "/backoffice/coreUtility-postman";
    E_CoreUtility["CacheManagementTFFI"] = "/backoffice/coreUtility-cache-management-tffi";
    E_CoreUtility["ConfigList"] = "/backoffice/coreUtility-config-list";
    E_CoreUtility["EmailConcurrencyTest"] = "/backoffice/customer-package-email/send-target-email";
    E_CoreUtility["postBatchTrial"] = "/backoffice/batch-trial/add";
    E_CoreUtility["postAccountJobRoleComplement"] = "/backoffice/account-job-role-complement/upload";
})(E_CoreUtility || (E_CoreUtility = {}));
/* 产品 */
export var E_ProductManager;
(function (E_ProductManager) {
    E_ProductManager["ProductRolesGetList"] = "/backoffice/product/roles/{product}";
    E_ProductManager["ResourcesRoleLimitationGetList"] = "/backoffice/resources/role/{productRoleId}/limitation";
    E_ProductManager["ResourcesGetList"] = "/backoffice/resources/product/{productId}/module/{module}";
    E_ProductManager["RoleResourceImport"] = "/backoffice/role-resource/importing";
    E_ProductManager["ProductClientsGetList"] = "/backoffice/clients";
    E_ProductManager["ProductGet"] = "/backoffice/products";
    E_ProductManager["ProductPost"] = "/backoffice/products";
    E_ProductManager["ProductDelete"] = "/backoffice/products/{productId}";
})(E_ProductManager || (E_ProductManager = {}));
/* 系统 */
export var E_SystemManager;
(function (E_SystemManager) {
    E_SystemManager["SystemConfiguration"] = "/backoffice/products";
    E_SystemManager["SearchEngineManagement"] = "SearchEngineManagement";
    E_SystemManager["CacheManagement"] = "/backoffice/redis/namespaces";
    E_SystemManager["SynchronizationRedis"] = "SynchronizationRedis";
    E_SystemManager["SamlConfigGetList"] = "/backoffice/saml/config/pagination";
    E_SystemManager["SqlGetList"] = "/backoffice/sql";
})(E_SystemManager || (E_SystemManager = {}));
/* 搜索引擎管理 */
export var E_SearchEngineManagement;
(function (E_SearchEngineManagement) {
    E_SearchEngineManagement["CompanyIndexGetList"] = "/backoffice/companies/solr/companies";
    E_SearchEngineManagement["AccountIndexGetList"] = "/backoffice/accounts/email";
    // HistoryIndexGetList = '/backoffice/logauditrecords/elasticsearch/index'
})(E_SearchEngineManagement || (E_SearchEngineManagement = {}));
export var E_SynchronizationRedis;
(function (E_SynchronizationRedis) {
    E_SynchronizationRedis["RedisPublishmentResourceUpdatedTopic"] = "/backoffice/redis/publishment/resource/updated-topic";
    E_SynchronizationRedis["RedisSynchronizationSoiResource"] = "/backoffice/redis/synchronization/soi/resource";
})(E_SynchronizationRedis || (E_SynchronizationRedis = {}));
// #endregion
/**
 * 套餐
 */
export var PermissionResourceEdit;
(function (PermissionResourceEdit) {
    PermissionResourceEdit["ProductResourceList"] = "/backoffice/resources/product/{product}";
    PermissionResourceEdit["ResourceList"] = "/backoffice/capacity-resources/pagination";
    PermissionResourceEdit["ResourceCreate"] = "/backoffice/capacity-resources/resource";
    PermissionResourceEdit["ResourceEdit"] = "/backoffice/capacity-resources/resource";
    PermissionResourceEdit["ServiceItem"] = "/backoffice/services/{roleId}";
    PermissionResourceEdit["ServiceList"] = "/backoffice/services/pagination";
    PermissionResourceEdit["ServiceCreate"] = "/backoffice/services/service";
    PermissionResourceEdit["ServiceEdit"] = "/backoffice/services/service";
    PermissionResourceEdit["ServiceClone"] = "/backoffice/services/service/clone";
    PermissionResourceEdit["ServiceResourceLimitationsList"] = "/backoffice/services/service/resource-limitations";
    PermissionResourceEdit["ServiceResourceLimitationsCreate"] = "/backoffice/services/service/resource-limitations";
    PermissionResourceEdit["ServiceResourceLimitationsEdit"] = "/backoffice/services/service/resource-limitations";
    PermissionResourceEdit["ServiceResourceLimitationsDelete"] = "/backoffice/services/service/resource-limitations";
    PermissionResourceEdit["CapacityList"] = "/backoffice/capacities/pagination";
    PermissionResourceEdit["CapacityCreate"] = "/backoffice/capacities";
    PermissionResourceEdit["CapacityEdit"] = "/backoffice/capacities/capacity";
    PermissionResourceEdit["PackagesList"] = "/backoffice/packages/pagination";
    PermissionResourceEdit["PackagesCreate"] = "/backoffice/packages";
    PermissionResourceEdit["PackagesEdit"] = "/backoffice/packages";
})(PermissionResourceEdit || (PermissionResourceEdit = {}));
/**
 * 公司和用户的Capacity详情
 */
export var CapacityDetail;
(function (CapacityDetail) {
    CapacityDetail["CapacityDetailCompany"] = "/backoffice/company-capacity/{companyId}";
    CapacityDetail["CapacityDetailAccount"] = "/backoffice/tenant-user-capacity/capacity";
})(CapacityDetail || (CapacityDetail = {}));
/**
 * 订单相关
 */
export var CompanyOrder;
(function (CompanyOrder) {
    CompanyOrder["OrdersList"] = "/backoffice/orders/company/{companyId}";
    CompanyOrder["OrderDetail"] = "/backoffice/orders/{id}";
    CompanyOrder["OrderAdd"] = "/backoffice/orders";
    CompanyOrder["OrderEdit"] = "/backoffice/orders";
    CompanyOrder["OrderEnable"] = "/backoffice/orders/{id}/enable";
    CompanyOrder["OrderDisable"] = "/backoffice/orders/{id}/disable";
    CompanyOrder["CompanyPrivilegeContractDelete"] = "/backoffice/company-privilege-contract/{id}/disable";
    CompanyOrder["CompanyCapacityContractDelete"] = "/backoffice/company-capacity-contract/{id}/disable";
    CompanyOrder["CompanyCapacityContractAllDelete"] = "/backoffice/company-capacity-contract/{orderId}/capacities/disable";
    CompanyOrder["OrderContractExisted"] = "/backoffice/orders/contract/contract-number";
    CompanyOrder["OrderEditCheck"] = "/backoffice/orders/update-order/check";
    CompanyOrder["CompanyOrderOpenapiEmbed"] = "/backoffice/openapi-embed/enabled";
})(CompanyOrder || (CompanyOrder = {}));
// #region 数据分析
export var E_DataAnalysis;
(function (E_DataAnalysis) {
    E_DataAnalysis["UserAnalysis"] = "/backoffice/user-analysis";
})(E_DataAnalysis || (E_DataAnalysis = {}));
// #endregion
// #region 行为分析
export var EP_Behavior;
(function (EP_Behavior) {
    EP_Behavior["ActiveBoard"] = "/backoffice/companies/enterprise/type";
})(EP_Behavior || (EP_Behavior = {}));
// #endregion
// #region GlobalView
export var EP_GlobalView;
(function (EP_GlobalView) {
    EP_GlobalView["GlobalViewList"] = "/backoffice/customer-view/global-view/pagination";
})(EP_GlobalView || (EP_GlobalView = {}));
// #endregion
// #region 行为分析
export var EP_Admin;
(function (EP_Admin) {
    EP_Admin["AdminPatsnapAccountList"] = "/backoffice/accounts/patsnap";
    EP_Admin["AdminRoleList"] = "/backoffice/product/roles/{product}";
    EP_Admin["AdminHistory"] = "/backoffice/log-audit-account-role";
    EP_Admin["AdminAddPatsnapAccount"] = "/backoffice/accounts/patsnap";
    EP_Admin["AdminAuditList"] = "/backoffice/logauditrecords/log-audit/operator-pagination";
    EP_Admin["AdminCorsWhitelist"] = "/backoffice/cors/whitelist";
})(EP_Admin || (EP_Admin = {}));
// #endregion
// #region 发版计划
export var EP_ReleasePlan;
(function (EP_ReleasePlan) {
    EP_ReleasePlan["ReleasePlanList"] = "/backoffice/release-plan";
    EP_ReleasePlan["ReleasePlanDetail"] = "/backoffice/release-plan/{id}";
    EP_ReleasePlan["ReleasePlanAdd"] = "/backoffice/release-plan";
    EP_ReleasePlan["ReleasePlanUpdate"] = "/backoffice/release-plan";
    EP_ReleasePlan["RelasePlanSwitchEnabled"] = "/backoffice/release-plan";
})(EP_ReleasePlan || (EP_ReleasePlan = {}));
// #endregion
// #region 活动推广链接
export var EP_ActivityPromotion;
(function (EP_ActivityPromotion) {
    EP_ActivityPromotion["GetActivityPromotionList"] = "/backoffice/activity-promotion/pagination";
    EP_ActivityPromotion["GetActivityPromotionProduct"] = "/backoffice/activity-promotion/product/package-key";
    EP_ActivityPromotion["PatchActivityPromotionEnabled"] = "/backoffice/activity-promotion/{id}/enabled/{enabled}";
    EP_ActivityPromotion["GetActivityPromotionItem"] = "/backoffice/activity-promotion/{id}";
    EP_ActivityPromotion["PostActivityPromotionItem"] = "/backoffice/activity-promotion";
    EP_ActivityPromotion["PutActivityPromotionItem"] = "/backoffice/activity-promotion";
    EP_ActivityPromotion["PostActivityPromotionCampaignsSync"] = "/backoffice/campaigns/sync";
})(EP_ActivityPromotion || (EP_ActivityPromotion = {}));
// #endregion
// #region 通知中心
export var EP_Notifications;
(function (EP_Notifications) {
    /**
     * 消息列表
     */
    EP_Notifications["PostNotificationUserMessageList"] = "/backoffice/notification-user-message/pagination";
    /**
     * 消息配置列表/backoffice/notification-scenes/pagination
     */
    EP_Notifications["PostNotificationScenesList"] = "/backoffice/notification-scenes/pagination";
    /**
     * 新增消息配置 /backoffice/notification-scenes
     */
    EP_Notifications["PostNotificationScenes"] = "/backoffice/notification-scenes";
})(EP_Notifications || (EP_Notifications = {}));
// #endregion
// #region 产品资源位管理
export var EP_ProductResourceSpaceManagement;
(function (EP_ProductResourceSpaceManagement) {
    /**
     * 产品线
     */
    EP_ProductResourceSpaceManagement["GetProductLine"] = "/backoffice/product-line";
    /**
     * 资源位
     */
    EP_ProductResourceSpaceManagement["GetResourceSpace"] = "/backoffice/resource-space/{product-line-id}/list";
    /**
     * 资源位内容
     */
    EP_ProductResourceSpaceManagement["GetResourceSpaceContent"] = "/backoffice/resource-space-content/pagination";
})(EP_ProductResourceSpaceManagement || (EP_ProductResourceSpaceManagement = {}));
// #region 数据分析
export var EP_DataAnalysis;
(function (EP_DataAnalysis) {
    EP_DataAnalysis["GetCompanyDataAnalysis"] = "/backoffice/company-data-analysis/report";
    EP_DataAnalysis["GetCompanyDataAnalysisDetail"] = "/backoffice/company-data-analysis/detail";
    EP_DataAnalysis["GetCompanyDataAnalysisWsDashboard"] = "/backoffice/company-data-analysis/summary-stat";
})(EP_DataAnalysis || (EP_DataAnalysis = {}));
// #endregion
export var EP_PqlRuleManagement;
(function (EP_PqlRuleManagement) {
    EP_PqlRuleManagement["GetPqlRuleManagementList"] = "/backoffice/rule-center/rule-managements";
    EP_PqlRuleManagement["PostPqLRuleDataAnalysisList"] = "/backoffice/rule-center/rule-data-analyzes";
})(EP_PqlRuleManagement || (EP_PqlRuleManagement = {}));
